import React, { useState } from 'react';

import { Form, FormControl, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Suggestion from './suggestion';
const Index = ({ data }) => {
  const [keyword, setKeyword] = useState('');
  const [show, setShow] = useState(false);
  const history = useHistory();

  const handleKeyword = (e) => {
    setShow(true);
    setKeyword(e.target.value);
  };

  return (
    <div className='SearchForm'>
      {/* <section className='InputhWrapper'>
        <input
          type='search'
          placeholder='search here'
          className='InputhWrapper-box'
        />
      </section> */}
      <Form className='d-flex'>
        <FormControl
          type='search'
          value={keyword}
          onChange={(e) => {
            handleKeyword(e);
          }}
          placeholder='Search food'
          className='mr-2 bradL'
          aria-label='Search'
        />
        <Link to={keyword !== '' ? `/search/${keyword}` : '#'}>
          <Button variant='outline-success ' className='bradR'>
            <i className='fa fa-search'></i>
          </Button>
        </Link>
      </Form>

      <div className='SearchForm-result'>
        {show &&
          keyword !== '' &&
          data
            .filter((item) =>
              item.toLowerCase().includes(keyword.toLowerCase())
            )
            .map((item, i) => (
              <p
                key={i}
                onClick={(e) => {
                  setKeyword('');
                  history.push(`/search/${item}`);
                  setShow(false);
                }}
              >
                {item}
              </p>
            ))}
      </div>
    </div>
  );
};

export default Index;
